(function () {
  function init(r) {
    if (r.dataset.dnInit) return;
    var sl = r.querySelectorAll('.dn-sl');
    var box = r.querySelector('.dn-slider');
    var dw = r.querySelector('.dn-dots');
    if (!box || !dw) return;
    r.dataset.dnInit = '1';
    if (sl.length === 1) return;
    var ms = parseInt(box.dataset.interval, 10) || 4000;
    var i = 0, t = null, dt = [];
    [].forEach.call(sl, function (x, k) {
      var b = document.createElement('b');
      if (k === 0) b.className = 'on';
      dw.appendChild(b);
      dt.push(b);
    });
    function go(n) {
      sl[i].classList.remove('on');
      dt[i].classList.remove('on');
      i = (n + sl.length) % sl.length;
      sl[i].classList.add('on');
      dt[i].classList.add('on');
    }
    function start() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      clearInterval(t);
      t = setInterval(function () { go(i + 1); }, ms);
    }
    box.addEventListener('mouseenter', function () { clearInterval(t); });
    box.addEventListener('mouseleave', start);
    dt.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    start();
  }
  function all() {
    [].forEach.call(document.querySelectorAll('.dn-hero'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
